(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.hasAttribute('data-lv-ba-ready')) return;
      el.setAttribute('data-lv-ba-ready', '');
      var range = el.querySelector('[data-lv-ba-range]');

      function set(v) {
        v = Math.max(0, Math.min(100, v));
        el.style.setProperty('--lv-ba-pos', v + '%');
        el.classList.toggle('is-low', v < 32);
        el.classList.toggle('is-high', v > 68);
        if (range) range.value = Math.round(v);
      }

      if (range) {
        range.addEventListener('input', function () { set(parseFloat(range.value) || 0); });
      }
      set(range ? parseFloat(range.value) || 0 : 20);

      var dragging = false, startX = 0, startY = 0, decided = false;

      function pos(e) {
        var r = el.getBoundingClientRect();
        return (e.clientX - r.left) / r.width * 100;
      }

      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        decided = e.pointerType === 'mouse';
        startX = e.clientX;
        startY = e.clientY;
        if (decided) { set(pos(e)); e.preventDefault(); }
      });

      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; }
          decided = true;
        }
        set(pos(e));
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
        el.addEventListener(t, function () { dragging = false; });
      });
    }

    function run() { document.querySelectorAll('[data-lv-ba]').forEach(init); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    var loading = null;

    function loadSwiper(useCdn) {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (!useCdn) {
        // Wait for a Swiper the theme loads itself
        return new Promise(function (resolve) {
          var tries = 0;
          (function wait() {
            if (window.Swiper) return resolve(window.Swiper);
            if (tries++ > 100) return resolve(null);
            setTimeout(wait, 100);
          })();
        });
      }
      if (loading) return loading;
      loading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = SWIPER_JS;
        s.async = true;
        s.onload = function () { resolve(window.Swiper); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
      return loading;
    }

    function LvPhotoSlider(root) {
      this.root = root;
      this.el = root.querySelector('.lv-ph__swiper');
      var cfgEl = root.querySelector('[data-lv-ph-config]');
      this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      this.mq = window.matchMedia('(min-width: 750px)');
      this.swiper = null;
      this.token = 0;
      this.onChange = this.update.bind(this);
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onChange);
      else this.mq.addListener(this.onChange);
      this.update();
    }

    LvPhotoSlider.prototype.options = function (desktop) {
      var c = this.cfg;
      var m = desktop ? c.desktop : c.mobile;
      var root = this.root;
      var effect = c.effect || 'slide';
      var spv = m.spv;
      if (effect === 'fade' || effect === 'cards' || effect === 'creative') spv = 1;

      var o = {
        slidesPerView: spv,
        spaceBetween: m.gap,
        slidesOffsetBefore: m.offset,
        slidesOffsetAfter: m.offset,
        speed: c.speed,
        loop: !!c.loop,
        rewind: !c.loop && !!c.rewind,
        centeredSlides: !!c.centered,
        initialSlide: c.initialSlide || 0,
        grabCursor: !!c.grabCursor,
        watchOverflow: true,
        effect: effect,
        a11y: { enabled: true },
        keyboard: { enabled: !!c.keyboard, onlyInViewport: true },
        mousewheel: c.mousewheel ? { forceToAxis: true } : false
      };

      if (effect === 'slide') {
        o.slidesPerGroup = Math.max(1, Math.min(c.slidesPerGroup || 1, Math.floor(spv) || 1));
        if (c.freeMode) o.freeMode = { enabled: true, sticky: !!c.freeModeSticky };
      }
      if (effect === 'fade') o.fadeEffect = { crossFade: true };
      if (effect === 'coverflow') {
        o.coverflowEffect = { rotate: c.coverflowRotate, depth: c.coverflowDepth, stretch: 0, modifier: 1, slideShadows: false };
      }
      if (effect === 'cards') o.cardsEffect = { slideShadows: false, perSlideOffset: 8, perSlideRotate: 2 };
      if (effect === 'creative') {
        o.creativeEffect = {
          prev: { shadow: false, translate: ['-20%', 0, -1], opacity: 0.6 },
          next: { translate: ['100%', 0, 0] }
        };
      }

      if (c.autoplay) {
        o.autoplay = {
          delay: Math.round(c.delay * 1000),
          disableOnInteraction: !!c.stopOnInteraction,
          pauseOnMouseEnter: !!c.pauseOnHover,
          reverseDirection: !!c.reverse
        };
      }

      if (m.arrows) {
        o.navigation = {
          prevEl: root.querySelector('.lv-ph__arrow--prev'),
          nextEl: root.querySelector('.lv-ph__arrow--next')
        };
      }

      if (m.pagination && c.paginationType !== 'none') {
        o.pagination = {
          el: root.querySelector('.lv-ph__pagination'),
          type: c.paginationType,
          clickable: !!c.paginationClickable,
          dynamicBullets: c.paginationType === 'bullets' && !!c.dynamicBullets
        };
      }

      if (m.scrollbar) {
        o.scrollbar = {
          el: root.querySelector('.lv-ph__scrollbar'),
          draggable: !!c.scrollbarDraggable,
          hide: false
        };
      }

      return o;
    };

    LvPhotoSlider.prototype.update = function () {
      var self = this;
      var desktop = this.mq.matches;
      var wanted = desktop ? this.cfg.desktopSlider : this.cfg.mobileSlider;
      var token = ++this.token;

      this.destroySwiper();
      if (!wanted || !this.el) return;

      loadSwiper(this.cfg.useCdn).then(function (Swiper) {
        if (!Swiper || self.dead || token !== self.token) return;
        self.swiper = new Swiper(self.el, self.options(desktop));
      }).catch(function () {});
    };

    LvPhotoSlider.prototype.destroySwiper = function () {
      if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
      this.swiper = null;
    };

    LvPhotoSlider.prototype.destroy = function () {
      this.dead = true;
      this.token++;
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onChange);
      else this.mq.removeListener(this.onChange);
      this.destroySwiper();
    };

    LvPhotoSlider.prototype.selectBlock = function (blockId) {
      if (!this.swiper) return;
      var slides = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-block-id') === blockId) {
          if (this.swiper.params.loop) this.swiper.slideToLoop(i);
          else this.swiper.slideTo(i);
          if (this.swiper.autoplay && this.swiper.autoplay.running) this.swiper.autoplay.stop();
          break;
        }
      }
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-lv-ph]').forEach(function (root) {
        if (root._lvph) return;
        root._lvph = new LvPhotoSlider(root);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-lv-ph]').forEach(function (root) {
        if (root._lvph) { root._lvph.destroy(); root._lvph = null; }
      });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-lv-ph]');
      if (root && root._lvph) root._lvph.selectBlock(e.detail.blockId);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('[data-lv-ph]');
      if (root && root._lvph && root._lvph.swiper && root._lvph.swiper.params.autoplay && root._lvph.swiper.params.autoplay.enabled) {
        root._lvph.swiper.autoplay.start();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-box-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function toInt(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }

    function LvReviews(root) {
      var d = root.dataset;
      this.root = root;
      this.grid = root.querySelector('[data-rb-grid]');
      this.store = root.querySelector('[data-rb-store]');
      this.moreWrap = root.querySelector('[data-rb-more-wrap]');
      this.moreBtn = root.querySelector('[data-rb-more]');
      this.cards = Array.prototype.slice.call(this.grid.querySelectorAll('.lv-rb__card'));
      this.cfg = {
        initM: toInt(d.initialMobile, 4),
        initD: toInt(d.initialDesktop, 6),
        batchM: toInt(d.batchMobile, 4),
        batchD: toInt(d.batchDesktop, 6),
        colsM: toInt(d.colsMobile, 2),
        colsT: toInt(d.colsTablet, 2),
        colsD: toInt(d.colsDesktop, 3)
      };
      this.shownM = this.cfg.initM;
      this.shownD = this.cfg.initD;
      this.mqD = window.matchMedia('(min-width: 750px)');
      this.mqL = window.matchMedia('(min-width: 990px)');

      this.onMq = this.layout.bind(this, -1);
      this.onMore = this.more.bind(this);
      this.onGridClick = this.gridClick.bind(this);
      this.onKey = this.key.bind(this);

      [this.mqD, this.mqL].forEach(function (mq) {
        if (mq.addEventListener) mq.addEventListener('change', this.onMq); else mq.addListener(this.onMq);
      }, this);
      if (this.moreBtn) this.moreBtn.addEventListener('click', this.onMore);
      this.grid.addEventListener('click', this.onGridClick);

      this.setupLightbox();
      this.layout(-1);
    }

    LvReviews.prototype.isDesktop = function () { return this.mqD.matches; };

    LvReviews.prototype.layout = function (animateFrom) {
      var desk = this.isDesktop();
      var cols = this.mqL.matches ? this.cfg.colsD : (desk ? this.cfg.colsT : this.cfg.colsM);
      var limit = desk ? this.shownD : this.shownM;
      var grid = this.grid;
      var store = this.store;

      grid.classList.add('lv-rb__grid--cols');
      grid.innerHTML = '';
      var colEls = [];
      for (var c = 0; c < Math.max(1, cols); c++) {
        var col = document.createElement('div');
        col.className = 'lv-rb__col';
        grid.appendChild(col);
        colEls.push(col);
      }

      this.cards.forEach(function (card, i) {
        card.classList.remove('lv-rb__card--in');
        if (i < limit) {
          var target = colEls[0];
          for (var k = 1; k < colEls.length; k++) {
            if (colEls[k].offsetHeight < target.offsetHeight) target = colEls[k];
          }
          target.appendChild(card);
          if (animateFrom >= 0 && i >= animateFrom) card.classList.add('lv-rb__card--in');
        } else if (store) {
          store.appendChild(card);
        }
      });

      if (this.moreWrap) this.moreWrap.style.display = limit < this.cards.length ? 'flex' : 'none';
    };

    LvReviews.prototype.more = function () {
      var desk = this.isDesktop();
      var from = desk ? this.shownD : this.shownM;
      if (desk) this.shownD += this.cfg.batchD; else this.shownM += this.cfg.batchM;
      this.layout(from);
    };

    LvReviews.prototype.showCard = function (blockId) {
      var idx = -1;
      this.cards.forEach(function (c, i) { if (c.getAttribute('data-block-id') === blockId) idx = i; });
      if (idx < 0) return;
      if (this.isDesktop()) { if (idx >= this.shownD) this.shownD = idx + 1; }
      else if (idx >= this.shownM) this.shownM = idx + 1;
      this.layout(-1);
      this.cards[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    /* Lightbox */
    LvReviews.prototype.setupLightbox = function () {
      var lb = this.root.querySelector('[data-rb-lightbox]');
      if (!lb) return;
      document.body.appendChild(lb); // avoid transformed parents breaking position: fixed
      this.lb = lb;
      this.lbImg = lb.querySelector('[data-rb-lightbox-img]');
      this.lbCap = lb.querySelector('[data-rb-lightbox-caption]');
      this.lbClose = lb.querySelector('[data-rb-close]');
      var self = this;
      this.onLbClick = function (e) { if (e.target === lb || e.target.closest('[data-rb-close]')) self.closeLightbox(); };
      lb.addEventListener('click', this.onLbClick);
    };

    LvReviews.prototype.gridClick = function (e) {
      var btn = e.target.closest('[data-rb-zoom]');
      if (!btn || !this.lb) return;
      this.lastFocus = btn;
      this.lbImg.src = btn.getAttribute('data-rb-zoom');
      this.lbImg.alt = btn.getAttribute('data-rb-caption') || '';
      this.lbCap.textContent = btn.getAttribute('data-rb-caption') || '';
      this.lb.hidden = false;
      var lb = this.lb;
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      document.documentElement.classList.add('lv-rb-lock');
      document.addEventListener('keydown', this.onKey);
      this.lbClose.focus();
    };

    LvReviews.prototype.closeLightbox = function () {
      if (!this.lb || this.lb.hidden) return;
      var lb = this.lb;
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('lv-rb-lock');
      document.removeEventListener('keydown', this.onKey);
      setTimeout(function () { lb.hidden = true; }, 250);
      if (this.lastFocus) this.lastFocus.focus();
    };

    LvReviews.prototype.key = function (e) {
      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'Tab') { e.preventDefault(); this.lbClose.focus(); }
    };

    LvReviews.prototype.destroy = function () {
      [this.mqD, this.mqL].forEach(function (mq) {
        if (mq.removeEventListener) mq.removeEventListener('change', this.onMq); else mq.removeListener(this.onMq);
      }, this);
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.classList.remove('lv-rb-lock');
      if (this.lb && this.lb.parentNode) this.lb.parentNode.removeChild(this.lb);
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-lv-rb]').forEach(function (root) {
        if (root._lvrb) return;
        root._lvrb = new LvReviews(root);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-lv-rb]').forEach(function (root) {
        if (root._lvrb) { root._lvrb.destroy(); root._lvrb = null; }
      });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.shopify-section');
      var root = section && section.querySelector('[data-lv-rb]');
      if (root && root._lvrb) root._lvrb.showCard(e.detail.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-button-3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function LvSticky(el) {
      this.el = el;
      this.btn = el.querySelector('[data-lv-sticky-btn]');
      this.label = el.querySelector('[data-lv-st-label]');
      this.err = el.querySelector('[data-lv-st-error]');
      this.showAfter = parseInt(el.getAttribute('data-show-after'), 10) || 0;
      this.hideNearFooter = el.getAttribute('data-hide-near-footer') === 'true';
      this.afterAdd = el.getAttribute('data-after-add') || 'drawer';
      this.footer = document.querySelector('footer, .footer, #shopify-section-footer, [id*="__footer"]');
      this.onScroll = this.check.bind(this);
      this.onClick = this.add.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      if (this.btn) this.btn.addEventListener('click', this.onClick);
      this.check();
    }

    LvSticky.prototype.check = function () {
      var show = window.scrollY >= this.showAfter;
      if (show && this.hideNearFooter && this.footer) {
        var r = this.footer.getBoundingClientRect();
        if (r.top < window.innerHeight) show = false;
      }
      this.el.classList.toggle('is-visible', show);
      this.el.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (this.btn) this.btn.tabIndex = show ? 0 : -1;
    };

    LvSticky.prototype.add = function () {
      var self = this;
      var btn = this.btn;
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      if (this.err) this.err.hidden = true;

      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = {
        items: [{
          id: parseInt(this.el.getAttribute('data-variant-id'), 10),
          quantity: parseInt(this.el.getAttribute('data-quantity'), 10) || 1
        }]
      };
      if (this.afterAdd === 'drawer' && drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');

          if (self.afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
          if (self.afterAdd === 'cart') { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }

          // Drawer (Dawn-style themes) or fallback
          if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
            var item = res.data.items && res.data.items[0] ? res.data.items[0] : {};
            var payload = Object.assign({}, item, { sections: res.data.sections, id: item.key });
            drawer.classList.remove('is-empty');
            drawer.renderContents(payload);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var added = btn.getAttribute('data-added');
            if (added) {
              self.label.textContent = added;
              setTimeout(function () { self.label.textContent = btn.getAttribute('data-label'); }, 2000);
            }
            if (!drawer) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
          }
        })
        .catch(function (e) {
          if (self.err) { self.err.textContent = e.message; self.err.hidden = false; }
        })
        .then(function () { btn.classList.remove('is-loading'); });
    };

    LvSticky.prototype.destroy = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-lv-sticky]').forEach(function (el) {
        if (el._lvst) return;
        el._lvst = new LvSticky(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-lv-sticky]').forEach(function (el) {
        if (el._lvst) { el._lvst.destroy(); el._lvst = null; }
      });
    });
    document.addEventListener('shopify:section:select', function (e) {
      var el = e.target.querySelector('[data-lv-sticky]');
      if (el) { el.classList.add('is-visible'); el.setAttribute('aria-hidden', 'false'); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-timer-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { n = n < 0 ? 0 : n; return (n < 10 ? '0' : '') + n; }

    function tzParts(date, tz) {
      try {
        var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
        var o = {};
        f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
        return { y: +o.year, mo: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
      } catch (e) { return null; }
    }
    function wallToEpoch(y, mo, d, h, mi, tz) {
      var utcGuess = Date.UTC(y, mo - 1, d, h, mi, 0);
      var p = tzParts(new Date(utcGuess), tz);
      if (!p) return utcGuess;
      var wallAsUtc = Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s);
      return utcGuess - (wallAsUtc - utcGuess);
    }
    function nextDailyEndMs(timeStr, tz) {
      var t = (timeStr || '23:59').split(':');
      var H = (+t[0]) || 0, M = (+t[1]) || 0;
      var now = new Date(), nowMs = now.getTime();
      var p = tzParts(now, tz);
      if (!p) return nowMs + 86400000;
      var target = wallToEpoch(p.y, p.mo, p.d, H, M, tz);
      if (target <= nowMs) {
        var nd = new Date(Date.UTC(p.y, p.mo - 1, p.d) + 86400000);
        target = wallToEpoch(nd.getUTCFullYear(), nd.getUTCMonth() + 1, nd.getUTCDate(), H, M, tz);
      }
      return target;
    }

    function initBar(el) {
      if (el._lvcd) return;
      var mode = el.getAttribute('data-mode') || 'evergreen';
      var total = parseInt(el.getAttribute('data-seconds'), 10) || 43200;
      var showDays = el.getAttribute('data-show-days') === 'true';
      var onEnd = el.getAttribute('data-on-end') || 'zeros';
      var dEl = el.querySelector('[data-cd-d]'), hEl = el.querySelector('[data-cd-h]');
      var mEl = el.querySelector('[data-cd-m]'), sEl = el.querySelector('[data-cd-s]');
      var endMs, key, daily;

      if (mode === 'daily') {
        daily = { time: el.getAttribute('data-daily-time') || '23:59', tz: el.getAttribute('data-daily-tz') || 'Europe/Berlin' };
        endMs = nextDailyEndMs(daily.time, daily.tz);
      } else if (mode === 'fixed') {
        var raw = (el.getAttribute('data-deadline') || '').trim().replace(' ', 'T');
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(raw)) raw += ':00';
        var tz = (el.getAttribute('data-tz') || '').trim();
        if (tz && !/(Z|[+\-]\d\d:?\d\d)$/.test(raw)) raw += tz;
        var t = Date.parse(raw);
        endMs = isNaN(t) ? Date.now() + total * 1000 : t;
      } else {
        key = 'lvCd_' + (el.getAttribute('data-id') || 'x') + '_' + total;
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
        if (!stored || stored < Date.now()) {
          stored = Date.now() + total * 1000;
          try { localStorage.setItem(key, stored); } catch (e) {}
        }
        endMs = stored;
      }

      function tick() {
        var rem = Math.floor((endMs - Date.now()) / 1000);
        if (rem <= 0) {
          if (mode === 'evergreen') {
            endMs = Date.now() + total * 1000;
            try { if (key) localStorage.setItem(key, endMs); } catch (e) {}
            rem = total;
          } else if (mode === 'daily') {
            endMs = nextDailyEndMs(daily.time, daily.tz);
            rem = Math.max(0, Math.floor((endMs - Date.now()) / 1000));
          } else {
            rem = 0;
            if (onEnd === 'hide') {
              var sec = el.closest('.shopify-section');
              (sec || el).style.display = 'none';
            }
          }
        }
        var d = 0, h;
        if (showDays) { d = Math.floor(rem / 86400); h = Math.floor((rem % 86400) / 3600); }
        else { h = Math.floor(rem / 3600); }
        var m = Math.floor((rem % 3600) / 60), s = rem % 60;
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }

      tick();
      el._lvcd = setInterval(tick, 1000);
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-lv-cd]').forEach(initBar); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-lv-cd]').forEach(function (el) {
        if (el._lvcd) { clearInterval(el._lvcd); el._lvcd = null; }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
